// axios

export default {
	data: function(){
		return {
		}
	},
    methods: {
        
        // color: 'green' ou 'red' senão fica primary
        // time: default 5 sec
        notify(text, color, seconds){
            let icon = 'icon-alert-circle';
            let time = seconds == null ? 5*1000 : seconds*1000;
            
            if(color == 'green'){
                color = 'success';
                icon = 'icon-check';
	        	if(text == '' || text == null){
	        		text = 'Success';
	        	}
            }else if(color == 'red'){
                color = 'danger';
                icon = 'icon-alert-triangle';
	        	if(text == '' || text == null){
	        		text = 'Erro';
	        	}
            }else{
                color = 'primary';
            }
            this.$vs.notify({
                time: time,
                text: text,
                color: color,
                iconPack: 'feather',
                icon: icon,
                position:'top-center'
            })
        },
        updateLocale(locale) {
            this.$i18n.locale = locale;
            window.localStorage.setItem('locale', locale);
        },
        
    }
}